/**
 * User entity factory. Represents both the signed-in user and team
 * members assigned to cases.
 */
import type { RawRecord } from './raw'

export interface User {
  id: string | number | null
  name: string
  initials: string
  role: string
  email: string
  /** Optional CSS override for the avatar chip. */
  avatarStyle: string
  workspace: string
  /**
   * The account tier (D-015): `firm_main`, `firm_manager`, `client_viewer`.
   * A named field because pages decide on it — only the main account may
   * delete an opposition case — and `raw.userKind` is the kind of read that
   * returns undefined the day the adapter changes.
   */
  userKind: string
  raw: RawRecord
}

export function createUser(raw: RawRecord = {}): User {
  return {
    id: raw.id ?? null,
    name: raw.name ?? '',
    initials: raw.initials ?? '',
    role: raw.role ?? '',
    email: raw.email ?? '',
    avatarStyle: raw.avatarStyle ?? '', // optional CSS override for avatar
    workspace: raw.workspace ?? '',
    userKind: raw.userKind ?? '',
    raw,
  }
}

export function createUserList(rawList: RawRecord[] = []): User[] {
  return rawList.map(createUser)
}
